import { Box } from '@pets-ui/Box/Box'
import { Link } from '@pets-ui/Link/Link'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { typography } from '@pets-ui/tokens/typography.stylex'
import { type ExtendStyleProps } from '@pets-ui/utils/makeExtendStyle/makeExtendStyle'
import * as stylex from '@stylexjs/stylex'
import { type ComponentPropsWithoutRef, type ForwardedRef } from 'react'

const baseStyle = stylex.create({
  link: {
    margin: '4px 0',
    padding: '8px 12px',
    borderRadius: 4,
    textDecoration: 'none',
    transition: 'all 0.2s ease-in-out',
    backgroundColor: {
      'default': colors.primary600,
      ':hover': colors.primary700,
    },
    color: colors.white,
    cursor: 'pointer',
    display: 'inline-block',
    fontSize: typography.sizeBody,
    fontWeight: typography.weightSemibold,
    textAlign: 'center',
    width: '100%',
  },
})

export interface PopupActionsProps extends ExtendStyleProps, ComponentPropsWithoutRef<'div'> {
  rootRef?: ForwardedRef<HTMLDivElement>
  title?: string
  link?: string
  onClick?: () => void
  onPopupClickEvent?: () => void
}

export const PopupActions = (props: PopupActionsProps) => {
  const { title, link, rootRef, onClick, onPopupClickEvent, ...rest } = props

  const handleClick = () => {
    onClick?.()
    onPopupClickEvent?.()
  }

  if (!title) return null

  return (
    <div ref={rootRef} {...rest}>
      <Box>
        <Link target="_blank" href={link} onClick={handleClick} rootStyle={baseStyle.link}>
          {title}
        </Link>
      </Box>
    </div>
  )
}
